module.exports = __webpack_public_path__ + "img/blue5.46e543ff.jpg";